import { useContext } from 'react';

import { FormSpy, useField } from 'react-final-form';

import { Tooltip, Stack, tokens } from '@cast/design-system';

import { AlertsWrapper } from './AlertsWrapper';
import { SettingsForm } from '../../../../_woop-settings/_components/layout/SettingsForm';
import { WorkloadDetailsContext } from '../../../_context';
import { useHpaDisabledReasons } from '../../_hooks/useHpaDisabledReasons';
import { ExplanationTooltip } from '../ExplanationTooltip';

import { RffControlsProvider, RffInput } from '@cast/shared-rff-ui';

export const AvailableHpaForm = () => {
  const { workload } = useContext(WorkloadDetailsContext);
  const { isDisabled } = useHpaDisabledReasons(workload);
  const {
    input: { value: isRightsizingEnabled },
  } = useField('horizontalRightsizing.enabled');

  const inputs = (
    <Stack direction="row" gap={8}>
      <RffInput
        name="horizontalRightsizing.pods.min"
        type="number"
        label="Min"
        size="medium"
        min={0}
        hintAbsolute
        placeholder="e.g. 2"
        testId="minPods"
        endAdornment="pods"
        fullWidth
      />
      <RffInput
        name="horizontalRightsizing.pods.max"
        type="number"
        label="Max"
        size="medium"
        min={0}
        placeholder="e.g. 10"
        hintAbsolute
        testId="maxPods"
        endAdornment="pods"
        fullWidth
      />
    </Stack>
  );

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values: { horizontalRightsizing } }) => {
        return (
          <RffControlsProvider readOnly={!horizontalRightsizing?.enabled}>
            <Stack position="relative">
              <AlertsWrapper>
                <Stack
                  px={28}
                  py={20}
                  borderRadius={1}
                  bgcolor={tokens.theme.bg.structural.surface}
                >
                  <SettingsForm
                    title="Pod count"
                    description="Set the desired minimum and maximum replica limits, that will apply to all workloads within this policy. The workloads will not be scaled above or below the limits"
                  >
                    {
                      // When hpa editing is possible, but hpa itself is disabled show tooltip with suggestion to enable it
                      !isDisabled && !isRightsizingEnabled ? (
                        <Tooltip title="Horizontal rightsizing needs to be enabled in order to set the values for the pod count.">
                          {inputs}
                        </Tooltip>
                      ) : (
                        <ExplanationTooltip>{inputs}</ExplanationTooltip>
                      )
                    }
                  </SettingsForm>
                </Stack>
              </AlertsWrapper>
            </Stack>
          </RffControlsProvider>
        );
      }}
    </FormSpy>
  );
};
